import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { StringParam, withDefault, useQueryParams } from 'use-query-params';
import withQueryParamsProvider from '../../../../../shared/components/withQueryParamsProvider';
import AffiliateOverview from '../AffiliateOverview';

const OverviewTab = props => {
  const [query, setQuery] = useQueryParams({
    tab: withDefault(StringParam, ''),
  });

  const { tab } = query;

  useEffect(() => {
    setQuery({ tab: 'overview' }, 'replaceIn');
  }, [tab]);

  return (
    <AffiliateOverview
      affiliateId={props.id}
      affiliate={props.affiliate}
      updateAffiliate={props.updateAffiliate}
    />
  );
};

OverviewTab.propTypes = {
  id: PropTypes.number.isRequired,
  affiliate: PropTypes.shape({
    bookingsTotal: PropTypes.number,
    travelersTotal: PropTypes.number,
    currentWorkspacesSize: PropTypes.number,
    chargeableChannelCount: PropTypes.number,
    ndcChannelCount: PropTypes.number,
    clientName: PropTypes.string,
    briefing: PropTypes.string,
    briefingUpdatedAt: PropTypes.string,
  }).isRequired,
  updateAffiliate: PropTypes.func.isRequired,
};

export default withQueryParamsProvider(OverviewTab);
